import { IonIcon } from '@ionic/react';
import Button from 'components/core/Button/Button';
import { logoGithub, logoLinkedin, logoMedium } from 'ionicons/icons';
import { HStack, VStack } from 'reaction';
import './ContactMeSection.css';

export default function ContactMeSection() {
    return (
        <HStack className='contact-me-section' justify='end'>
            <VStack className='find-me-on' align='start'>
                <h2>Find Me On</h2>

                <Button onClick={() => undefined} className='find-me-on-button'>
                    <HStack>
                        <IonIcon icon={logoGithub} className='find-me-on-icon' />
                        GitHub
                    </HStack>
                </Button>

                <Button onClick={() => undefined} className='find-me-on-button'>
                    <HStack>
                        <IonIcon icon={logoLinkedin} className='find-me-on-icon' />
                        LinkedIn
                    </HStack>
                </Button>

                <Button onClick={() => undefined} className='find-me-on-button'>
                    <HStack>
                        <IonIcon icon={logoMedium} className='find-me-on-icon' />
                        Medium
                    </HStack>
                </Button>
            </VStack>
        </HStack>
    );
}
